// Type et mise en forme d'une ligne de commission, partagés par le tableau de la fiche
// partenaire et la modale de détail.

export type Commission = {
	id: number;
	attributionId?: number;
	billingAccountId: string;
	invoiceId?: string;
	collectedAmount?: number;
	rate?: number;
	amount?: number;
	currency?: string;
	status: string;
	payoutId?: number;
	collectedAt?: string;
	unlockableAt?: string;
	createdAt?: string;
	forced?: boolean;
	originalRate?: number;
	editNote?: string;
	editedBy?: string;
	editedAt?: string;
};

type StatusChip = { label: string; color: 'success' | 'warning' | 'default' };

const STATUS: Record<string, StatusChip> = {
	available: { label: 'Déblocable', color: 'success' },
	requested: { label: 'En cours de règlement', color: 'warning' },
	paid: { label: 'Réglée', color: 'default' },
};

export const eur = (n?: number) =>
	new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n || 0);

export const fmtDate = (d?: string) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

// Statut AFFICHÉ d'une ligne : le statut stocké ne suffit pas.
//
// `available` veut dire « ligne valide, pas encore réglée » — PAS « déblocable ». Le hold
// (la ligne doit avoir passé le trimestre de maturité) est porté par `unlockableAt`, figé
// à la création. Les afficher toutes deux « Déblocable », comme cet écran le faisait,
// laisse croire qu'un virement est possible dès l'encaissement : c'est de l'argent qu'on
// annonce à un partenaire, et l'erreur ne se voit qu'au moment de refuser le déblocage.
export const displayStatus = (c: Commission): StatusChip => {
	if (c.status === 'available' && c.unlockableAt && new Date(c.unlockableAt) > new Date()) {
		return { label: `En attente jusqu'au ${fmtDate(c.unlockableAt)}`, color: 'warning' };
	}
	return STATUS[c.status] || { label: c.status, color: 'default' };
};

// Seule une ligne pas encore engagée dans un versement se retouche : au-delà, son montant
// fait partie d'un total demandé ou versé (l'API répond 409).
export const isEditable = (c: Commission) => c.status === 'available' && !c.payoutId;
